import axios from '../../../configs/axios';

const createCustomExport = requestData => axios.post('/custom_exports', requestData);
const updateCustomExport = (id, updatedData) => axios.put(`/custom_exports/${id}`, updatedData);
const deleteCustomExport = id => axios.delete(`/custom_exports/${id}`, { data: { id } });

const fetchCustomExports = (filters, searchParams = '') => axios.get(`/custom_exports.json${searchParams}`, {
  params: {
    request: {
      assets: {
        reports: {
          filters,
        },
      },
    },
  },
});

const fetchSavedCustomExports = (currentPage) => {
  const filters = {
    query: null,
    sort_by: 'created_at',
    sort_order: 'desc',
    pagination: {
      per_page: 15,
      total: 0,
      current_page: currentPage,
    },
  };
  return fetchCustomExports(filters, '?entities_icons_count=0');
};

const fetchMarketData = id => axios.get(`/my_markets/${id}/general_data.json`);

const fetchCompanyMpiData = companyIds => axios.post('/mpis/for_companies', {
  company_ids: companyIds,
});

const fetchCrossAppsData = requestData => axios.get('/custom_exports/cross_app_similar_apps', requestData);
// fetchCrossAppsData requestData = unified_ref_no, query, limit, offset, panel_version

export default {
  createCustomExport,
  updateCustomExport,
  deleteCustomExport,
  fetchSavedCustomExports,
  fetchMarketData,
  fetchCompanyMpiData,
  fetchCrossAppsData,
};
